import { Card, CardContent, CardHeader, styled } from "@woba/ds-web";
import { ScoreCardSkeleton } from "@/_old/components/data-display/score-card";
import { VisibleBreakpoint } from "@/_old/components/visible-breakpoint";
import { SkeletonCircle, SkeletonRect } from "@/_old/lib/skeleton";

const ItemWrapper = styled("div", {
  paddingTop: "$space-06",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "$space-03",
});

export const QualitySkeleton = () => {
  return (
    <Card css={{ maxWidth: 332 }}>
      <CardHeader css={{ gap: "$space-04", marginBottom: "$space-04" }}>
        <SkeletonRect height={32} />
        <SkeletonRect height={24} width={100} />
      </CardHeader>
      <CardContent css={{ gap: "$space-09", justifyContent: "center" }}>
        <VisibleBreakpoint breakpoint="md" type="max">
          <ScoreCardSkeleton />
          <ScoreCardSkeleton />
        </VisibleBreakpoint>
        <VisibleBreakpoint breakpoint="md" type="min">
          <ItemWrapper>
            <SkeletonCircle width={82} height={82} />
            <SkeletonRect width={30} />
          </ItemWrapper>
          <ItemWrapper>
            <SkeletonCircle width={82} height={82} />
            <SkeletonRect width={30} />
          </ItemWrapper>
        </VisibleBreakpoint>
      </CardContent>
    </Card>
  );
};
